import React, { useEffect } from "react";
import Loader from "../../Layout/Loader";
import ErrorComponent from "../ErrorComponent";


const ErrorFallback = ({ error }) => {
    // Handles failed lazy loading of a JS/CSS chunk.
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    useEffect(() => {
        if (localStorage.getItem('counter') === "1") {
            localStorage.removeItem('counter');
            return false
        }
        localStorage.setItem('counter', "1");
        if (error?.message && chunkFailedMessage.test(error.message)) {
            window.location.reload()
        }
    }, [error]);

    return (error?.message && chunkFailedMessage.test(error.message) ? <Loader /> : <ErrorComponent error={error} />)


};


export default ErrorFallback